import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripHtml'
})
export class StripHtmlPipe implements PipeTransform {
  constructor() {}
  transform(htmlText) {
    const html = htmlText
    .replace(/<div>/g, `<div>\n`)
    .replace(/<br>/g, `<br>\n`)
    .replace(/<p>/g, `<p>\n`);

    const tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    const textContent = (tmp.textContent || tmp.innerText || '').trim();

    return textContent;
  }
}
